// extracted by mini-css-extract-plugin
export default {"Icon":"informationIcon_Icon__0fxPx"};